import { render, staticRenderFns } from "./pendencia-solicitacao-layout.vue?vue&type=template&id=c1b7d1fe&scoped=true"
import script from "./pendencia-solicitacao-layout.vue?vue&type=script&lang=ts"
export * from "./pendencia-solicitacao-layout.vue?vue&type=script&lang=ts"
import style0 from "./pendencia-solicitacao-layout.vue?vue&type=style&index=0&id=c1b7d1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b7d1fe",
  null
  
)

export default component.exports